export default "<div class=\"content\">\r\n    <ng-content></ng-content>\r\n</div>\r\n\r\n      "